<!--资格码报单-->
<template>
  <div>
    <app-breadcrumb />
    <div v-loading="doLoading" class="page-container Qualification">
      <el-table v-if="isAgent" :data="list" border size="mini" fit highlight-current-row max-height="270px"
        style="width: 100%;margin-bottom: 20px">
        <!--经销商编号-->
        <el-table-column :label="$t('miMember.memberNo')" prop="havedNo" align="center" />
        <!--资格码-->
        <el-table-column :label="$t('Qualification_code')" prop="qualificationCode" align="center">
          <template slot-scope="scope">
            <span v-if="!scope.row.qOrderNo" @click="copyData(scope.row.qualificationCode)" style="color: #b3640d">{{
              scope.row.qualificationCode }}</span>
            <span v-else style="color: #999999">{{ scope.row.qualificationCode }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('pdWarehouseStock.productNo')" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.procType.includes('当月促销')">
              {{ goodsList[0].goodsCode }} x{{ goodsList[0].buyQty }} ({{ goodsList[0].priceL }}$)
            </span>
            <span v-else>
              {{ goodsList[1].goodsCode }} x{{ goodsList[1].buyQty }} ({{ goodsList[1].priceL }}$)
            </span>
          </template>
        </el-table-column>
        <!--订单编号-->
        <el-table-column :label="$t('poOrder.orderNo')" prop="qOrderNo" align="center">
          <template slot-scope="scope">
            {{ scope.row.qOrderNo ? scope.row.qOrderNo : $t('Unused') }}
          </template>
        </el-table-column>
      </el-table>
      <el-form label-width="auto" size="mini">
        <el-row :gutter="20">
          <el-col :md="12" :lg="12" :xl="12">
            <el-form-item size="mini" :label="$t('miMember.memberNo') + ':'" class="hong-xing">
              <!--:readonly="memberNoDisabled"-->
              <el-input :class="{ 'disabled_remove_css': memberNoDisabled }" v-model.trim="formData.memberNo" clearable
                :placeholder="$t('')" @blur="getAgentNo()" />
            </el-form-item>
          </el-col>
          <el-col :md="12" :lg="8" :xl="6">
            <p :class="{ 'account_name_css': account_name_show }"
              style="color:#538E0D; font-weight:bold; line-height: 4px;">
              {{
                memberNoData.accountName }}
            </p>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :md="12" :lg="12" :xl="12">
            <!--资格码-->
            <el-form-item size="mini" :label="$t('Qualification_code') + ':'" class="hong-xing">
              <el-input v-model.trim="formData.qualificationCode" clearable :placeholder="$t('')"
                @blur="checkQualificationCode()" />
            </el-form-item>
          </el-col>
          <el-col :md="12" :lg="8" :xl="6">
            <p :class="{ 'account_name_css': qualificationAble }" style="font-weight:bold; line-height: 4px;">
            </p>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :md="12" :lg="12" :xl="12">
            <!--支付方式-->
            <el-form-item size="mini" :label="$t('poOrder.payWay') + ':'" class="hong-xing">
              <span v-if="formData.goodsList.length">
                {{ formData.goodsList[0].priceL }} $
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <div v-if="!isAgent">
          <el-row :gutter="20">
            <el-col :md="12" :lg="12" :xl="12">
              <!--        收货人姓名-->
              <el-form-item size="mini" :label="$t('PoOrder.recName')" class="hong-xing">
                <el-input v-model.trim="formData.name" clearable :placeholder="$t('')" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :md="12" :lg="12" :xl="12">
              <!--        联系电话-->
              <el-form-item size="mini" :label="$t('sysCompany.phone')" class="hong-xing">
                <el-input v-model.trim="formData.recPhone" clearable :placeholder="$t('')" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :md="12" :lg="12" :xl="12">
              <!--        收货地址-->
              <el-form-item :label="$t('ssCustomer.saddress')">
                <el-radio-group class="radio-group" v-model="formData.recType">
                  <el-radio :label="1">
                    {{ this.$t('pick.up.from.franchise') }}:{{ memberNoData.agentNo }} - {{ memberNoData.agentName }}
                  </el-radio>
                  <div style="margin: 10px 0" />
                  <el-radio :label="2">
                    {{ this.$t('pick.up.from.branch.office') }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row :gutter="20">
          <el-col :md="12" :lg="12" :xl="12">
            <!--         支付密码 -->
            <el-form-item size="mini" :label="$t('please.input.your.pay.password')" class="hong-xing">
              <el-input v-model.trim="formData.payPassword" show-password clearable placeholder="" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :md="12" :lg="12" :xl="12">
            <el-form-item size="mini" :label="$t('pdWarehouseStock.productNo')">
              <span v-if="formData.goodsList.length">
                {{ formData.goodsList[0].goodsCode }} x1
              </span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: center; margin-bottom: 10px;margin-top: 10px">
        <!--        提交-->
        <el-button size="mini" :loading="doLoading" type="success" icon="el-icon-check" @click="formSubmit">
          {{ $t('title.submit') }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {
  miMemberInfo,
  procQualificationCanUse,
  procQualificationListByAgent,
  procQualificationSaveOrder
} from "@/api/member";
import { mapGetters } from "vuex";

export default {
  name: 'Qualification',
  directives: {},
  components: {},
  data() {
    return {
      formData: {
        payPassword: '',
        memberNo: '',
        qualificationCode: '',
        payType: '',
        name: '',
        recPhone: '',
        recType: '',
        storeAddr: '',
        goodsList: [{ goodsCode: '-', buyQty: 1, priceL: 0 }]
      },
      memberNoData: {
        accountName: null
      },
      list: [],
      qualificationAble: false,
      memberNoDisabled: false,
      account_name_show: false,
      doLoading: false,
      total: 0,
      goodsList: [
        { goodsCode: 'M003-00', buyQty: 1, priceL: 200 },
        { goodsCode: 'M010-00', buyQty: 1, priceL: 300 },
      ]
    }
  },
  computed: {
    ...mapGetters([
      'userCode',
      'companyCode',
      'isAgent'
    ]),
  },
  watch: {},
  beforeCreate() {
  },
  created() {
    this.getAgentNo()
    if (this.isAgent) {
      this.getList()
    }
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  activated() {
  },
  methods: {
    getList() {
      this.doLoading = true
      procQualificationListByAgent().then(res => {
        this.doLoading = false
        this.list = res.data
      }).catch(err => {
        console.error(err)
        this.doLoading = false
      })
    },
    checkQualificationCode() {
      this.doLoading = true
      this.qualificationAble = false
      console.log(this.formData.qualificationCode)
      this.formData.goodsList = []
      procQualificationCanUse({
        qualificationCode: this.formData.qualificationCode
      }).then(res => {
        this.doLoading = false
        this.qualificationAble = false
        // console.log(res.data.procType)
        if (res.data.procType.includes('当月促销')) {
          this.formData.goodsList[0] = this.goodsList[0]
        } else {
          this.formData.goodsList[0] = this.goodsList[1]
        }
      }).catch(err => {
        console.error(err)
        this.doLoading = false
        this.qualificationAble = true
      })
    },
    async getAgentNo() {
      this.memberNoDisabled = !this.isAgent
      this.formData.memberNo = !this.isAgent ? this.userCode : this.formData.memberNo
      if (this.formData.memberNo) {
        try {
          this.doLoading = true
          let res = await miMemberInfo({ memberNo: this.formData.memberNo })
          this.memberNoData = res.data
          this.formData.name = this.memberNoData.name
          this.formData.recPhone = this.memberNoData.mobile
          this.formData.storeAddr = this.memberNoData.storeAddr
          this.doLoading = false
          this.account_name_show = false
          console.log(JSON.parse(JSON.stringify(this.memberNoData)))
        } catch (err) {
          console.log(err)
          this.doLoading = false
          this.memberNoData.accountName = ''
          this.account_name_show = true
        }
      }
    },
    formSubmit() {
      console.log(this.formData, 'formData')
      if (!this.formData.memberNo) {
        this.$message.warning(this.$t('label.pleaseFillIn').toString() + ' ' + this.$t('miMember.memberNo').toString())
        return
      }
      if (!this.formData.qualificationCode) {
        this.$message.warning(this.$t('label.pleaseFillIn').toString() + ' ' + this.$t('Qualification_code').toString())
        return
      }
      if (!this.formData.payPassword) {
        this.$message.warning(this.$t('please.input.your.pay.password').toString())
        return
      }
      // 促销金额赋值
      // totalAmount = 金额
      // totalpointa0 = EDollar
      // totalF0 = F000
      this.formData.totalAmount = this.formData.goodsList[0].priceL
      this.formData.totalpointa0 = 0
      this.formData.totalF0 = 0
      this.doLoading = true
      procQualificationSaveOrder({ ...this.formData }).then(() => {
        this.doLoading = false
        this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
        this.$router.push({ name: 'OrderQuery' })
      }).catch(err => {
        console.error(err)
        this.doLoading = false
      })
    },
    copyData(val) {
      // navigator.clipboard.writeText(val).then(()=>{
      //   this.$message.success('copy success')
      // })
      const textArea = document.createElement('textArea')
      textArea.value = val
      textArea.style.width = 0
      textArea.style.position = 'fixed'
      textArea.style.left = '-999px'
      textArea.style.top = '10px'
      textArea.setAttribute('readonly', 'readonly')
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      this.$message.success('copy success')
      document.body.removeChild(textArea)
    },
  }
}

</script>

<style lang="scss" scoped>
.account_name_css:after {
  content: 'X';
  color: #ff4949;
}

.hong-xing {
  ::v-deep.el-form-item__label:before {
    content: "*";
    color: #F56C6C;
    margin-right: 4px;
  }
}
</style>
